import { Box, Checkbox, Divider, Typography, alpha } from "@mui/material";
import { UseTheme, UseMaterialColors } from "lib/hooks";
import { GetDeleteConfirmationStyles, GetRemoveSectorsConfirmationMessage } from "../deleteConfirmationStyles";

export interface RemoveSectorsConfirmationProps {
	checked: boolean;
	onCheckedChange: (checked: boolean) => void;
	wouldLoseMcc: boolean;
	userName: string;
	removedSectorNames: string[];
	/** When true, render a divider above the confirmation block (e.g. when inside a scrollable form). Default true. */
	showDivider?: boolean;
}

/**
 * Shared confirmation block for Edit Sector Admin and Edit Plant User when removing sectors.
 * Uses GetDeleteConfirmationStyles and GetRemoveSectorsConfirmationMessage for consistent copy and styling.
 */
export function RemoveSectorsConfirmation({
	checked,
	onCheckedChange,
	wouldLoseMcc,
	userName,
	removedSectorNames,
	showDivider = true,
}: RemoveSectorsConfirmationProps) {
	const { theme } = UseTheme();
	const materialColors = UseMaterialColors();
	const styles = GetDeleteConfirmationStyles({
		theme,
		materialColors,
		alpha,
	});
	const message = GetRemoveSectorsConfirmationMessage(wouldLoseMcc, userName, removedSectorNames);

	return (
		<>
			{showDivider && <Divider sx={{ ...styles.divider, my: 1 }} />}
			<Box sx={styles.confirmationBox}>
				<Checkbox
					checked={checked}
					onChange={(e) => onCheckedChange(e.target.checked)}
					sx={styles.checkbox}
				/>
				<Box sx={{ flex: 1 }}>
					<Typography
						variant="body2"
						sx={wouldLoseMcc ? styles.messageDestructive : styles.messageNormal}
					>
						{message}
					</Typography>
				</Box>
			</Box>
		</>
	);
}
